import * as React from "react";
import {
  Box,
  Card,
  CardContent,
  Fab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { CategoriesType } from "../../types/entitiesModel";
import { useNavigate } from "react-router-dom";
import BorderColorIcon from "@mui/icons-material/BorderColor";

interface AppTableProps {
  data: CategoriesType[];
}

const AppTable: React.FC<AppTableProps> = (props: AppTableProps) => {
  const navigate = useNavigate();

  const handleEditUser = (id: number) => {
    navigate(`/admin/categories/editCategory/${id.toString()}`);
  };

  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h3">Categorias</Typography>
          <Box
            sx={{
              overflowX: "auto",
              width: "100%",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                mt: 3,
                whiteSpace: "nowrap",
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Id
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Nombre
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Edad
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary" variant="h6">
                      Descripción
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography color="textSecondary" variant="h6">
                      Editar
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.data.map((cat: CategoriesType) => (
                  <TableRow key={cat.id}>
                    <TableCell>
                      <Typography sx={{ fontSize: "15px", fontWeight: "500" }}>
                        {cat.id}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h6" sx={{ fontWeight: "600" }}>
                          {cat.name}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h6" sx={{ fontWeight: "600" }}>
                          {cat.name}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography variant="h6" sx={{ fontWeight: "600" }}>
                          {cat.description}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell align="right">
                      <Fab
                        color="success"
                        aria-label="edit"
                        sx={{
                          width: 35,
                          height: 35,
                          cursor: "pointer",
                          backgroundColor: "green",
                          "&:hover": {
                            backgroundColor: "darkgreen",
                          },
                        }}
                        onClick={() => {
                          handleEditUser(cat.id);
                        }}
                      >
                        <BorderColorIcon
                          sx={{
                            width: 20,
                            height: 20,
                            widhtcolor: "white",
                          }}
                        />
                      </Fab>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AppTable;
